import {useState} from 'react';
import {sanitizeImgSrc, type Ticket} from '@overlayqa/shared';
import {ImageWithLoader} from '@overlayqa/shared/ui';
import {HugeiconsIcon} from '@hugeicons/react';
import {Image01Icon} from '@hugeicons/core-free-icons';
import {Link} from 'react-router-dom';
import {IssueIdWithCopy} from '../../shared/IssueIdWithCopy';
import {SeverityBadge} from '../../shared/badges/SeverityBadge';
import {TypeBadge} from '../../shared/badges/TypeBadge';
import {RowActionMenu} from '../../shared/RowActionMenu';
import {Avatar} from '../../ui/Avatar';
import {issuePath} from '../../../pages/issues/issuesPageColumns';
import type { RowAction } from '../../shared/DataTableTypes';
export type BoardMember = {id:string;name:string;avatarUrl?:string|null};
export function IssueBoardCard({issue,actions,members}:{issue:Ticket;actions:RowAction<Ticket>[];members:BoardMember[]}) {
 const member=members.find(member=>member.id===issue.assigneeId);
 const name=issue.assigneeId ? member?.name || 'Assigned teammate' : 'Unassigned';
 return <article className={`${issue.ignoredAt ? 'opacity-45' : ''} bg-white rounded-lg border border-[var(--color-card-stroke)] p-4 shadow-sm`}>
   <div className="flex items-center justify-between gap-2 mb-3"><IssueIdWithCopy displayId={issue.displayId} fallback={issue.id} className="text-xs text-gray-500"/><RowActionMenu item={issue} label={`Actions for ${issue.displayId ?? issue.title}`} actions={actions}/></div>
   <Link draggable={false} to={issuePath(issue)} className="block group">
     <IssueScreenshot url={issue.screenshotUrl || issue.fullPageScreenshotUrl || ''} title={issue.title}/>
     <h3 className="text-sm font-medium text-gray-900 group-hover:text-primary-600 leading-5 mt-3 break-words">{issue.title}</h3>
   </Link>
   <div className="flex flex-wrap items-center gap-2 mt-4"><SeverityBadge severity={issue.severity}/><TypeBadge type={issue.type}/></div>
   <div className="flex items-center gap-2 mt-3 text-xs text-gray-500"><Avatar id={issue.assigneeId ?? undefined} name={name} src={member?.avatarUrl} size="xs"/>{name}</div>
 </article>;
}

// Same preview surface as ProjectCard; contain preserves the entire issue capture.
function IssueScreenshot({url,title}:{url:string;title:string}) {
 const src=sanitizeImgSrc(url);
 const [failed,setFailed]=useState<string|null>(null);
 return <div className="issue-board-screenshot aspect-[3/2] rounded-lg bg-gray-100 overflow-hidden relative border border-gray-200">
   {src && failed!==src ? <ImageWithLoader fill src={src} alt={`Screenshot of ${title}`} draggable={false} loading="lazy" decoding="async" className="w-full h-full object-contain" onError={()=>setFailed(src)}/> : <div className="w-full h-full flex flex-col items-center justify-center gap-2 text-gray-500" role="img" aria-label="No screenshot"><HugeiconsIcon icon={Image01Icon} size={24} strokeWidth={1.5} aria-hidden="true"/><span className="text-xs">No screenshot</span></div>}
 </div>;
}
